import moment from 'moment';

export function formatLatency(ms) {
  if (ms === null || ms === undefined) return '–';
  if (ms < 1000) return `${ms}ms`;
  return `${(ms / 1000).toFixed(1)}s`;
}

export function buildApiPayload(filters, pagination = null) {
  const payload = {};

  if (filters.dateFrom) payload.dateFrom = filters.dateFrom;
  if (filters.dateTo) payload.dateTo = filters.dateTo;
  if (filters.direction) payload.direction = filters.direction;
  if (filters.flowType) payload.flowType = filters.flowType;
  if (filters.status) payload.status = filters.status;
  if (filters.search && filters.search.trim()) payload.search = filters.search.trim();

  if (pagination) {
    payload.page = pagination.page;
    payload.pageSize = pagination.pageSize;
  }

  return payload;
}

export function getDefaultFilters() {
  return {
    dateFrom: moment().subtract(24, 'hours').format('YYYY-MM-DD'),
    dateTo: moment().format('YYYY-MM-DD'),
    direction: null,
    flowType: null,
    status: null,
    search: '',
  };
}
